import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

// 2j: fester Schluss nach Teil 4. Text und Fassung kommen vom Server; der Klick wird am selben Logeintrag vermerkt.
export const SchlussBlock = ({ schluss }) => (
  <div className="space-y-3 border-t border-slate-200 pt-4" data-testid="kern-antwort-schluss" data-fassung={schluss.fassung}>
    {schluss.absaetze.map((t, i) => (
      <p key={i} className="text-base leading-relaxed text-slate-800" data-testid={`kern-antwort-schluss-absatz-${i + 1}`}>{t}</p>
    ))}
    {schluss.cta && (
      <Link
        to={schluss.cta.ziel}
        onClick={() => api.post("/schluss/klick", { log_id: schluss.log_id }).catch(() => {})}
        className="flex min-h-[52px] items-center justify-center rounded-2xl bg-slate-900 px-6 font-bold text-white"
        data-testid="kern-antwort-schluss-cta"
      >
        {schluss.cta.text}
      </Link>
    )}
  </div>
);

export default SchlussBlock;
